import addWindowScrollPositionToDocument from './modules/viewport';

// Add Lottie player
import '@lottiefiles/lottie-player';

// Custom modules
import CookieConsent from './modules/cookie-consent';
import initStickyHeader from './modules/sticky-header';
import initMobileMenuToggle from './modules/mobile-menu-toggle';
import initHeroSearch from './modules/search-suggestions';
import initTabs from './modules/tabs';
//import initCallMeBack from './modules/call-me-back';
import initCrosslinksSlider from './modules/crosslinks-slider';
import initRequestForm from './modules/request-form';
import initPartnersSlider from './modules/partners-slider';
import initHeroHomeSlider from './modules/hero-home-slider';
import initSearch from './modules/search-form';
import initSupport from './modules/support';
import initDownloadTipguide from './modules/download-tipguide';
import initVacancyResponse  from './modules/vacancy-response';
import initLandingspage  from './modules/landingspage';
import initNewsletter from "./modules/newsletter";
import initAnimationVideos from "./modules/animation-videos";

addWindowScrollPositionToDocument();

initStickyHeader();
initMobileMenuToggle();
initHeroSearch();
initTabs();
//initCallMeBack();
initCrosslinksSlider();
initRequestForm();
initPartnersSlider();
initHeroHomeSlider();
initSearch();
initSupport();
initDownloadTipguide();
initVacancyResponse();
initLandingspage();
initNewsletter();
initAnimationVideos();

window.onload = () => {
    if (document.querySelector('[data-cmeleon-cookie-notice]') !== null) {
        const cookieConsent = new CookieConsent(document);
        setTimeout(() => cookieConsent.showNotice(), 2000);
    }

    // Remove title attributes from images
    const images = document.querySelectorAll('img');
    images.forEach((image) => {
        image.setAttribute('title', '');
    });
};
